import { useTreatmentHistoryContext } from '@context/TreatmentHistory';
import {
  FocusableComponentLayout,
  FocusContext,
  useFocusable
} from '@noriginmedia/norigin-spatial-navigation';
import { TREATMENT_HISTORY_ROWS } from '@pages/TreatmentHistory/focusKey';
import dayjs from 'dayjs';
import { useEffect } from 'react';

import TreatmentListItem from '../TreatmentListItem';

import * as styles from './styles';
import { PaymentStatusEnum } from '@api/GoodocAPI';

const TreatmentList = () => {
  const { completionTreatments, setFirstRowFocus, scrollToItem, goTreatmentHistoryDetail } =
    useTreatmentHistoryContext();

  const { ref } = useFocusable({ focusKey: TREATMENT_HISTORY_ROWS });

  useEffect(() => {
    setFirstRowFocus();
  }, [setFirstRowFocus]);

  return (
    <FocusContext.Provider value={TREATMENT_HISTORY_ROWS}>
      <div css={styles.container}>
        <div ref={ref} css={styles.scrollContainer}>
          {completionTreatments &&
            completionTreatments?.map(
              (
                {
                  id,
                  status,
                  paymentStatus,
                  patient,
                  department,
                  doctor,
                  treatmentEndedAt,
                  prescription
                },
                i
              ) => (
                <TreatmentListItem
                  key={i}
                  index={i}
                  status={status}
                  paymentStatus={paymentStatus || PaymentStatusEnum.Requested}
                  patientName={patient.name ?? ''}
                  departmentName={department.name}
                  doctorName={doctor?.name}
                  hospitalName={doctor?.hospital.name}
                  treatmentEndedAt={dayjs(treatmentEndedAt).format('YYYY.MM.DD HH:mm')}
                  isPrescriptionExists={!!prescription}
                  onEnterPress={() => goTreatmentHistoryDetail(id)}
                  onFocus={(layout: FocusableComponentLayout) =>
                    scrollToItem(ref, layout)
                  }
                />
              )
            )}
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default TreatmentList;
